import { __assign, __rest } from "tslib";
import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef } from "react";
import { PlaceholderContainer } from "./styles";
export var Image = forwardRef(function Image(_a, ref) {
    var _b = _a.as, Component = _b === void 0 ? "img" : _b, props = __rest(_a, ["as"]);
    var src = props.src;
    if (src) {
        return _jsx(Component, __assign({ ref: ref }, props, { src: src }));
    }
    return _jsx(PlaceholderContainer, __assign({ ref: ref }, props));
});
//# sourceMappingURL=index.js.map